<dynamic-material-form
  class="kontakt-angabe-form"
  [model]="formModel"
  [group]="formGroup"
  (change)="onFormChange($event)"
  (matEvent)="onCustomEvent($event, null, true)"
  data-test="gsm-kontakt-angabe_form"
>
</dynamic-material-form>
<p [hidden]="hasContactInfo" [innerHTML]="model.noContactMessage" data-test="gsm-kontakt-angabe_no-contact-msg"></p>
<mat-checkbox
  [hidden]="hasContactInfo"
  [(ngModel)]="noContactConfirmed"
  (ngModelChange)="onNoContactCheckboxChange()"
  [ngModelOptions]="{ standalone: true }"
  [disabled]="model.disabled"
  data-test="gsm-kontakt-angabe_no-contact-checkbox"
>
  {{ model.noContactCheckboxLabel }} *
</mat-checkbox>
